import { DecimalPipe } from '@angular/common';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemProgressComponent } from '../../components/item-progress/item-progress.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import SymptomCheckService from '../../services/symptom-check.service';
import RestService from '../../services/core-rest.service';
import DialogServices from '../../services/dialog.service';
import BusinessRestServices from '../../services/business-rest.service';
import Session from '../../utils/session.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import moment from 'moment';
import { Input } from '@angular/core';
import { ModalConditionInfoComponent } from '../modal-condition-info/modal-condition-info.component';
import { ModalTreatmentGuidelineComponent } from '../modal-treatment-guideline/modal-treatment-guideline.component';

@Component({
	standalone: true,
	selector: 'symptom-check-results-pay',
	templateUrl: './symptom-check-results-pay.component.html',
	imports: [
		CommonModule, DecimalPipe, TranslatePipe, ItemProgressComponent, 
		LoaderOverlayComponent, FormsModule, RouterLink
	]
})
export class SymptomCheckResultsPayComponent implements OnInit {
	private symptomCheckService: SymptomCheckService = inject(SymptomCheckService);
	private restService: RestService = inject(RestService);
	private dialogServices: DialogServices = inject(DialogServices);
	private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
	private session: Session = inject(Session);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	
	@Input() interview: any;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.generalDescription = this.angularHelperService.trustAsHtml(
			this.angularFilterHelperService.translate('Symptom_Check.Results.Description')
		);
		this.vm.origin = this.session.getSession().user.origin;
		
		this.getTriage()
			.then(() => {
				this.getTriageContent();
				return this.getOnDemandServiceSettings();
			})
			.then(() => {
				this.vm.isInitialized = true;
				this.angularHelperService.createTimer(() => {
					this.symptomCheckService.updateInterview({});
				});
			})
			.catch(console.error);
		
		this.vm.openConditionInfo = this.openConditionInfo;
		this.vm.hasTreatmentGuideline = this.hasTreatmentGuideline;
		this.vm.openTreatmentGuideline = this.openTreatmentGuideline;
	};
	
	getTriage() {
		if (this.vm.interview.triage) {
			return this.angularHelperService.getPromise().resolve();
		}
		
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		var interview: any = this.angularHelperService.copy(this.vm.interview);
		interview.extras = { enableTriage5: true };
		
		var conditionRemoteIds: Array<any> = [];
		for (var conditionsKey in interview.diagnosis.conditions) {
			conditionRemoteIds.push(interview.diagnosis.conditions[conditionsKey].id);
		}
		this.restService.getConditionTreatmentGuidelines({ conditionRemoteId: conditionRemoteIds }).then(
			(response) => {
				this.vm.conditionTreatmentGuidelines = response;
			}).catch(
				(error) => {
					console.log(error);
				}
			);
		
		this.restService.saveTriage(interview)
			.then((res) => {
				this.vm.interview.triage = res;
				deferred.resolve();
			})
			.catch(console.error);
		
		return deferred.promise;
	}
	
	getTriageContent() {
		if (!this.vm.interview.triage) return;
		
		switch (this.vm.interview.triage.triage_level) {
			case 'self_care':
			{
				this.vm.title = this.angularFilterHelperService.translate('Symptom_Check.Results.Triage.Title.Self_Care');
				this.vm.description = this.angularFilterHelperService.translate('Symptom_Check.Results.Triage.Description.Self_Care');
				this.vm.icon = 'home';
				this.vm.isCallEnabled = true;
				this.vm.level = 1;
				break;
			}
			case 'consultation':
			{
				this.vm.title = this.angularFilterHelperService.translate('Symptom_Check.Results.Triage.Title.Consultation');
				this.vm.description = this.angularFilterHelperService.translate('Symptom_Check.Results.Triage.Description.Consultation');
				this.vm.icon = 'phone';
				this.vm.isCallEnabled = true;
				this.vm.level = 2;
				break;
			}
			case 'consultation_24':
			{
				this.vm.title = this.angularFilterHelperService.translate('Symptom_Check.Results.Triage.Title.Consultation_24');
				this.vm.description = this.angularFilterHelperService.translate('Symptom_Check.Results.Triage.Description.Consultation_24');
				this.vm.icon = 'phone';
				this.vm.isCallEnabled = true;
				this.vm.level = 3;
				break;
			}
			case 'emergency':
			{
				this.vm.title = this.angularFilterHelperService.translate('Symptom_Check.Results.Triage.Title.Emergency');
				this.vm.description = this.angularFilterHelperService.translate('Symptom_Check.Results.Triage.Description.Emergency');
				this.vm.icon = 'emergency';
				this.vm.level = 4;
				break;
			}
			case 'emergency_ambulance':
			{
				this.vm.title = this.angularFilterHelperService.translate('Symptom_Check.Results.Triage.Title.Emergency_Ambulance');
				this.vm.description = this.angularFilterHelperService.translate('Symptom_Check.Results.Triage.Description.Emergency_Ambulance');
				this.vm.icon = 'emergency';
				this.vm.level = 4;
				break;
			}
		}
	}
	
	getOnDemandServiceSettings() {
		if (!this.vm.isCallEnabled) {
			return this.angularHelperService.getPromise().resolve();
		}
		
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		var params: any = {
			origin: this.vm.origin
		};
		
		this.businessRestServices.getOnDemandSettings(params, (settings) => {
			var gmtHours: any = moment().utc().hours();
			var currencies: any = { 'EUR': '€', 'USD': '$', 'GBP': '£', 'PLN': 'zł‎', 'RUB': '₽', 'SEK': 'kr', 'DKK': 'kr.', 'NOK': 'kr'  };
			
			this.vm.service = settings.filter(function(item) {
				return item.subcategory === 'GENERAL_MEDICAL_PRACTICE' && item.furtherSubcategory === 'FAMILY_PHYSICIAN' 
			})[0];
			this.vm.buttonText = this.angularFilterHelperService.translate('Symptom_Check.Results.Button')
				.replace('%s', this.vm.service.price).replace('%s', currencies[this.vm.service.currency])
				.replace('%s', this.vm.service.timePerPrice);
			this.vm.isServiceAvailable = !this.vm.service.onHold
				&& (!this.vm.service.startTimeInHours || gmtHours >= this.vm.service.startTimeInHours)
				&& (!this.vm.service.endTimeInHours || gmtHours < this.vm.service.endTimeInHours);
			
			deferred.resolve();
		});
		
		return deferred.promise;
	}
	
	openConditionInfo(condition) {
		if (!condition) return;
		
		this.dialogServices.show({
			controller: ModalConditionInfoComponent,
			condition: condition,
			interview: this.vm.interview
		});
	}
	
	hasTreatmentGuideline(conditionId) {
		for (var index in this.vm.conditionTreatmentGuidelines) {
			if (this.vm.conditionTreatmentGuidelines[index].conditionRemoteId === conditionId) {
				return true;
			}
		}
		return false;
	}
	
	openTreatmentGuideline(conditionId) {
		var guideline: any = undefined;
		for (var index in this.vm.conditionTreatmentGuidelines) {
			if (this.vm.conditionTreatmentGuidelines[index].conditionRemoteId === conditionId) {
				guideline = this.vm.conditionTreatmentGuidelines[index];
			}
		}
		if (!guideline) {
			return;
		}
		var options: any = {
			title: guideline.conditionName,
			text: guideline.guidelines
		}
		this.dialogServices.show({
			controller: ModalTreatmentGuidelineComponent,
			options: options
		});
	}
	
}